import React from 'react';
import { Button, ButtonVariant } from '@/shared/components/Buttons';
import {
  Card,
  CardBody,
  CardContent,
  CardStyle,
} from '@/shared/components/Card';
import { Dialog } from '@/shared/components/Dialog';
import PopupIcon from '../../../assets/svg/AddUserPopupIcon.svg';

export interface RemoveServiceDialogProps {
  open: boolean;
  onClose: () => void;
  serviceName: string;
  onConfirm: () => void;
}

/**
 * Confirmation prompt shown before removing an already-added service from a
 * subscription plan (RR-1071 — "A confirmation prompt should be displayed
 * before performing the action"). Same template as CreateModal.tsx's
 * Discard Changes dialog, not a bespoke design.
 */
export const RemoveServiceDialog: React.FC<RemoveServiceDialogProps> = ({
  open,
  onClose,
  serviceName,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={380}>
      <Card style={CardStyle.Elevated} width={380}>
        <CardBody padding="large">
          <div className="flex flex-col items-center gap-6 text-center">
            <div className="flex items-center justify-center w-[137px] h-[137px]">
              <PopupIcon />
            </div>
            <CardContent
              title="Delete Service?"
              description={
                <>
                  Are you sure you want to delete{' '}
                  <span className="font-medium">{serviceName}</span>? All its
                  configured details will be removed.
                </>
              }
              className="!px-0 !py-0 flex flex-col items-center !gap-2 !text-[#474A4C] [&>p]:!font-normal"
            />
            <div className="flex flex-row items-center justify-center gap-3 w-full px-5">
              <Button
                label="Keep Service"
                onClick={onClose}
                className="!bg-transparent border border-[#DCDDE0] !text-on-surface-variant hover:!bg-neutral-95 hover:border-neutral-70 w-full cursor-pointer !rounded-[8px] !font-medium"
              />
              <Button
                label="Delete Service"
                variant={ButtonVariant.Primary}
                onClick={onConfirm}
                className="w-full cursor-pointer !rounded-[8px] !font-medium"
              />
            </div>
          </div>
        </CardBody>
      </Card>
    </Dialog>
  );
};

export default RemoveServiceDialog;
